import { useCopilot } from '../../CopilotContext';

import styles from './TypingIndicator.module.css';

export function TypingIndicator() {
  const { messages, awaitingReply } = useCopilot();
  const isTyping =
    awaitingReply || messages.some((m) => m.role === 'assistant' && m.pending);
  if (!isTyping) return null;
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <span className={styles.srOnly}>Copilot is typing</span>
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.dot} aria-hidden="true" />
    </div>
  );
}
